import React, { useEffect, useState } from "react";
import { Alert } from "antd";

// Banner del aviso eliminado (INF-584, modelo E24): la ficha de un aviso borrado redirige
// al listado de su categoría con ?addeletedid=<id>. Acá se muestra el aviso una vez y el
// param se limpia de la URL, para que no quede en links compartidos ni lo indexe Google.
export const DeletedAdBanner = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		if (!params.has("addeletedid")) return;
		setVisible(true);
		params.delete("addeletedid");
		const query = params.toString();
		// Saca el param de una URL en string (para limpiar también el estado del router).
		const sinParam = (u?: string) => {
			if (!u || u.indexOf("addeletedid") === -1) return u;
			const [base, resto = ""] = u.split("?");
			const q = new URLSearchParams(resto);
			q.delete("addeletedid");
			const querySinParam = q.toString();
			return base + (querySinParam ? "?" + querySinParam : "");
		};
		// Se preserva el estado del router de Next (con state null su onPopState no navega
		// y el botón Atrás queda roto), limpiando el param también dentro del estado para
		// que un Atrás posterior no restaure la URL con el param.
		const estado = window.history.state;
		window.history.replaceState(
			estado ? { ...estado, as: sinParam(estado.as), url: sinParam(estado.url) } : estado,
			"",
			window.location.pathname + (query ? "?" + query : "") + window.location.hash
		);
	}, []);

	if (!visible) return null;

	return (
		<Alert
			className="deleted-ad-banner"
			style={{ marginBottom: 16 }}
			type="info"
			showIcon
			closable
			message={"El anuncio ya no está disponible"}
			description={"Te mostramos alternativas similares para que continúes tu búsqueda."}
		/>
	);
};
